// Generated by bin/generate-feature-toggle-names.mjs. Do not edit manually.
//
// Canonical list of every feature-toggle name the UI references, extracted from
// useFeatureToggle('x'), <Feature name="x">, and sidebar feature: entries. Used
// to front-load toggle state for the current user in a single request at app
// startup (see AppLayout), so useFeatureToggle reads synchronously with no
// false→true flicker (TRK-4860). Regenerate with `bun run codegen`.
export const FEATURE_TOGGLE_NAMES = [
  `action-center`,
  `ai-agent-config-route`,
  `ai-agent-only-notifications`,
  `bulk-sms`,
  `dark-mode`,
  `dni`,
  `facebook-leads-personal-token`,
  `global-search`,
  `grouped-navigation`,
  `inbox-email`,
  `incoming-call-alerts`,
  `integrated-mode`,
  `needs-action-date`,
  `paperwork`,
  `pms-comm-log`,
  `related-contacts-prototype`,
  `revenue-dashboard`,
  `scheduled-sms`,
  `TRK-2569`,
  `TRK-2637`,
  `TRK-3672`,
  `workflows-builder`,
] as const
